/* =====================================================================
   TEMPLE OF TCG — Shopify Theme
   Warenkorb, Produktmedien, 360°-Ansicht und die gesamte Bewegung.

   Die Animationen laufen ohne externe Bibliothek: IntersectionObserver
   für die Aufdeckungen, ein einziger requestAnimationFrame-Lauf für
   alles, was am Scrollstand hängt. Damit kann kein fremder Server die
   Bewegung ausfallen lassen.

   Startzustände setzt ausschliesslich JavaScript. Ist JavaScript aus,
   steht die Seite vollständig und bedienbar da.
   ===================================================================== */
(function () {
  "use strict";

  var S = window.TOT_STRINGS || {};
  var R = window.TOT_ROUTES || {};
  var A = window.TOT_ANIM || {};

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var COARSE  = window.matchMedia("(hover:none),(pointer:coarse)").matches;
  var ANIM    = (A.enabled !== false) && !REDUCED;
  var AMP     = { subtle: 0.6, balanced: 1, strong: 1.45 }[A.intensity] || 1;
  var EASE    = "cubic-bezier(.16,1,.3,1)";

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ==================================================================
     1. Preisformat nach shop.money_format
     ================================================================== */
  function formatMoney(cents, format) {
    var fmt = format || window.TOT_MONEY_FORMAT || "{{amount}}";
    if (typeof cents === "string") cents = cents.replace(".", "");
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function num(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return "0";
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return whole + (parts[1] ? decimal + parts[1] : "");
    }

    var match = fmt.match(placeholder);
    var value;
    switch (match && match[1]) {
      case "amount_no_decimals":                       value = num(cents, 0, "’", "."); break;
      case "amount_with_comma_separator":              value = num(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator":  value = num(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator":         value = num(cents, 2, "’", "."); break;
      case "amount_no_decimals_with_space_separator":  value = num(cents, 0, " ", ","); break;
      case "amount_with_space_separator":              value = num(cents, 2, " ", ","); break;
      default:                                         value = num(cents, 2, "’", ".");
    }
    return fmt.replace(placeholder, value);
  }

  /* ==================================================================
     2. Kleine Helfer für Bewegung
     ================================================================== */
  function prep(el, css, transition) {
    if (!ANIM) return false;
    el.style.transition = "none";
    for (var k in css) el.style[k] = css[k];
    /* Layout erzwingen, damit der Startzustand wirklich greift */
    void el.offsetWidth;
    el.style.transition = transition;
    return true;
  }

  function release(el, delay) {
    el.style.transitionDelay = (delay || 0) + "ms";
    el.style.opacity = "";
    el.style.transform = "";
    el.style.clipPath = "";
    el.addEventListener("transitionend", function done(e) {
      if (e.target !== el) return;
      el.removeEventListener("transitionend", done);
      el.style.transition = "";
      el.style.transitionDelay = "";
    });
  }

  var io = null;
  var pending = [];

  function fire(el) {
    var i = pending.indexOf(el);
    if (i > -1) pending.splice(i, 1);
    if (io) io.unobserve(el);
    var cb = el.__totReveal;
    if (cb) { el.__totReveal = null; cb(); }
  }

  /* Zweiter Weg neben dem Observer: alles, was sichtbar im Bild steht,
     wird freigegeben. Fängt Randfälle ab, in denen ein Element für den
     Observer keine Fläche hat. */
  function sweep() {
    if (!pending.length) return;
    var vh = window.innerHeight;
    pending.slice().forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.95 && r.bottom > 0) fire(el);
    });
  }

  function onView(el, fn) {
    el.__totReveal = fn;
    if (!("IntersectionObserver" in window)) { fire(el); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) fire(en.target); });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.01 });
    }
    pending.push(el);
    io.observe(el);
  }

  /* Wörter kapseln, damit jedes einzeln aufsteigen kann */
  function splitWords(el) {
    if (el.dataset.splitDone) return $$(".split-word", el);
    el.dataset.splitDone = "1";
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          if (!child.nodeValue.trim()) return;
          var frag = document.createDocumentFragment();
          child.nodeValue.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement("span");
            s.className = "split-word";
            s.textContent = p;
            frag.appendChild(s);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && !child.classList.contains("split-word")) {
          walk(child);
        }
      });
    })(el);
    return $$(".split-word", el);
  }

  /* ==================================================================
     3. Hinweisbanner
     ================================================================== */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add("is-on"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-on"); }, 2800);
  }

  /* ==================================================================
     4. Warenkorb
     ================================================================== */
  var drawer, scrim;

  function openDrawer() {
    if (!drawer) return;
    scrim.classList.add("is-on");
    drawer.classList.add("is-on");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("no-scroll");
    staggerDrawer();
  }
  function closeDrawer() {
    if (!drawer) return;
    scrim.classList.remove("is-on");
    drawer.classList.remove("is-on");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
  }

  function pop(el) {
    if (!ANIM) return;
    el.style.transition = "none";
    el.style.transform = "scale(.55)";
    void el.offsetWidth;
    el.style.transition = "transform .55s cubic-bezier(.34,1.56,.64,1)";
    el.style.transform = "";
  }

  function paintCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      var was = parseInt(el.textContent, 10) || 0;
      el.textContent = n;
      el.style.display = n ? "" : "none";
      if (n !== was) pop(el);
    });
  }

  function renderCart(cart) {
    paintCount(cart.item_count);
    if (!drawer) return;
    var body = $("[data-cart-body]", drawer);
    var foot = $("[data-cart-foot]", drawer);

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="empty"><div class="jpmark">空</div><p class="lead">' + esc(S.empty) + "</p>" +
        '<p style="margin-top:18px"><a class="btn btn--sm" href="' + esc(R.all || "/collections/all") + '">' + esc(S.emptyCta) + "</a></p></div>";
      foot.innerHTML = "";
      return;
    }

    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[^.]*)$/, "_200x$1") : "";
      return '<div class="litem">' +
        '<div class="litem__img">' + (img ? '<img src="' + esc(img) + '" alt="">' : "") + "</div>" +
        '<div><a class="litem__name" href="' + esc(it.url) + '">' + esc(it.product_title) + "</a>" +
        (it.variant_title && it.variant_title !== "Default Title"
          ? '<div class="litem__meta">' + esc(it.variant_title) + "</div>" : "") +
        '<div class="litem__meta">' + esc(S.qty) + " " + it.quantity + "</div>" +
        '<button class="litem__rm" data-line="' + (i + 1) + '">' + esc(S.remove) + "</button></div>" +
        '<div class="price" style="font-size:17px">' + formatMoney(it.line_price) + "</div></div>";
    }).join("");

    foot.innerHTML =
      '<div class="sumrow"><span>' + esc(S.subtotal) + "</span><span>" + formatMoney(cart.total_price) + "</span></div>" +
      '<div class="sumrow"><span>' + esc(S.shipping) + "</span></div>" +
      '<div class="sumrow sumrow--total"><span>' + esc(S.subtotal) + '</span><span class="v">' + formatMoney(cart.total_price) + "</span></div>" +
      '<form action="' + esc(R.cart || "/cart") + '" method="post"><button class="btn btn--gold btn--block" type="submit" name="checkout" style="margin-top:16px">' + esc(S.checkout) + "</button></form>" +
      '<a class="btn btn--block" href="' + esc(R.cart || "/cart") + '" style="margin-top:10px">' + esc(S.viewCart) + "</a>";

    $$("[data-line]", body).forEach(function (b) {
      b.addEventListener("click", function () { changeLine(b.dataset.line, 0); });
    });

    if (drawer.classList.contains("is-on")) staggerDrawer();
  }

  function staggerDrawer() {
    if (!ANIM || !drawer) return;
    $$(".litem, .empty", drawer).forEach(function (el, i) {
      prep(el, { opacity: "0", transform: "translateX(" + (26 * AMP) + "px)" },
        "opacity .55s " + EASE + ", transform .55s " + EASE);
      release(el, i * 60);
    });
  }

  function fetchCart() {
    return fetch(R.cartJs || "/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; })
      .catch(function () {});
  }

  function addToCart(formData, btn) {
    if (btn) { btn.classList.add("is-busy"); btn.disabled = true; }
    return fetch((R.cartAdd || "/cart/add") + ".js", { method: "POST", body: formData })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || S.error); return; }
        return fetchCart().then(function () { toast(S.added); openDrawer(); });
      })
      .catch(function () { toast(S.error); })
      .then(function () { if (btn) { btn.classList.remove("is-busy"); btn.disabled = false; } });
  }

  function changeLine(line, qty) {
    return fetch((R.cartChange || "/cart/change") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        renderCart(c);
        if (document.body.classList.contains("template-cart")) window.location.reload();
        else if (qty === 0) toast(S.removed);
      })
      .catch(function () { toast(S.error); });
  }

  function initCart() {
    drawer = $("[data-cart-drawer]");
    scrim = $("[data-scrim]");
    if (scrim) scrim.addEventListener("click", closeDrawer);
    if (drawer) $("[data-drawer-close]", drawer).addEventListener("click", closeDrawer);

    $$("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); fetchCart(); });
    });

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.matches("form[data-product-form]")) return;
      e.preventDefault();
      addToCart(new FormData(form), form.querySelector('[type="submit"]'));
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeDrawer(); closeMenu(); closeSearch(); }
    });

    fetchCart();
  }

  /* ==================================================================
     5. Mengensteuerung
     ================================================================== */
  function initQty() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-qty-step]");
      if (!btn) return;
      var wrap = btn.closest(".qty");
      var input = wrap && wrap.querySelector("input");
      if (!input) return;
      var min = parseInt(input.min || "1", 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(btn.dataset.qtyStep, 10));
      pop(input);
      if (input.dataset.line) changeLine(input.dataset.line, parseInt(input.value, 10));
      else input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    document.addEventListener("change", function (e) {
      if (e.target.matches("input[data-line]")) {
        changeLine(e.target.dataset.line, parseInt(e.target.value, 10) || 0);
      }
    });
  }

  /* ==================================================================
     6. Produktmedien und 360°
     ================================================================== */
  var spinners = [];

  function dressModelViewer(mv) {
    mv.setAttribute("camera-controls", "");
    mv.setAttribute("touch-action", "pan-y");
    mv.setAttribute("interaction-prompt", "none");
    mv.setAttribute("shadow-intensity", "1.1");
    mv.setAttribute("shadow-softness", "0.9");
    mv.setAttribute("exposure", "1.05");
    mv.setAttribute("environment-image", "neutral");
    mv.setAttribute("auto-rotate", "");
    mv.setAttribute("auto-rotate-delay", "500");
    mv.setAttribute("rotation-per-second", "22deg");
  }

  function addSpinButton(frame, mv, label) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "viewer__spin";
    btn.textContent = label || "360°";
    btn.addEventListener("click", function () {
      if (mv.hasAttribute("auto-rotate")) { mv.removeAttribute("auto-rotate"); btn.classList.add("is-off"); }
      else { mv.setAttribute("auto-rotate", ""); btn.classList.remove("is-off"); }
    });
    frame.appendChild(btn);
  }

  function initMedia() {
    var gallery = $("[data-media-gallery]");
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = "1";

    var slides = $$("[data-media-slide]", gallery);
    var thumbs = $$("[data-media-thumb]");

    thumbs.forEach(function (th) {
      th.addEventListener("click", function () {
        var id = th.dataset.mediaThumb;
        thumbs.forEach(function (x) { x.classList.toggle("is-on", x === th); });
        slides.forEach(function (sl) { sl.hidden = sl.dataset.mediaSlide !== id; });
        var shown = gallery.querySelector('[data-media-slide="' + id + '"]');
        if (shown && ANIM) {
          prep(shown, { opacity: "0", transform: "scale(1.04)" },
            "opacity .55s " + EASE + ", transform .55s " + EASE);
          release(shown);
        }
      });
    });

    var mv = gallery.querySelector("model-viewer");
    if (mv) {
      dressModelViewer(mv);
      var frame = mv.closest(".media-frame") || mv.parentNode;
      addSpinButton(frame, mv, frame.dataset.spinLabel);
      spinners.push({ mv: mv, el: frame });
    }
  }

  function initHeroViewer() {
    $$("[data-hero-model]").forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = "1";
      var src = box.dataset.heroModel;
      if (!src) return;

      var fb = box.querySelector(".viewer__fallback");
      var mv = document.createElement("model-viewer");
      mv.setAttribute("src", src);
      mv.setAttribute("alt", box.dataset.heroAlt || "");
      dressModelViewer(mv);
      mv.setAttribute("camera-orbit", "18deg 78deg 105%");
      mv.setAttribute("disable-pan", "");
      mv.style.opacity = "0";
      mv.style.transition = "opacity .9s " + EASE;
      box.insertBefore(mv, fb || null);

      mv.addEventListener("load", function () {
        mv.style.opacity = "1";
        if (fb) { fb.style.opacity = "0"; fb.style.pointerEvents = "none"; }
      });
      mv.addEventListener("error", function () { mv.remove(); });
      setTimeout(function () {
        if (!(window.customElements && customElements.get("model-viewer"))) mv.remove();
      }, 9000);

      addSpinButton(box, mv, box.dataset.spinLabel);
    });
  }

  /* ==================================================================
     7. Kopfbereich, Menü, Suche
     ================================================================== */
  function closeMenu() {
    var m = $(".mnav");
    if (m) { m.classList.remove("is-open"); document.body.classList.remove("no-scroll"); }
  }
  function closeSearch() {
    var s = $(".hsearch");
    if (s) s.classList.remove("is-open");
  }

  function initShell() {
    if ($(".totop")) {
      $(".totop").addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: REDUCED ? "auto" : "smooth" });
      });
    }

    var burger = $("[data-burger]");
    var mnav = $(".mnav");
    if (burger && mnav) {
      burger.addEventListener("click", function () {
        mnav.classList.add("is-open");
        document.body.classList.add("no-scroll");
        if (!ANIM) return;
        $$(".mnav__list a", mnav).forEach(function (a, i) {
          prep(a, { opacity: "0", transform: "translateY(24px)" },
            "opacity .55s " + EASE + ", transform .55s " + EASE);
          release(a, 120 + i * 55);
        });
      });
      $$("[data-mnav-close], a", mnav).forEach(function (el) { el.addEventListener("click", closeMenu); });
    }

    var hs = $(".hsearch");
    if (hs) {
      $(".hsearch__toggle", hs).addEventListener("click", function (e) {
        e.stopPropagation();
        hs.classList.toggle("is-open");
        if (hs.classList.contains("is-open")) {
          var f = $("input", hs);
          setTimeout(function () { if (f) f.focus(); }, 220);
        }
      });
      document.addEventListener("click", function (e) {
        if (!hs.contains(e.target)) closeSearch();
      });
    }

    var here = window.location.pathname;
    $$(".nav a, .mnav__list a").forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (href.length > 1 && here.indexOf(href) === 0) a.classList.add("is-active");
      if (href === "/" && here === "/") a.classList.add("is-active");
    });

    $$("[data-auto-submit]").forEach(function (el) {
      el.addEventListener("change", function () {
        var f = el.closest("form");
        if (f) f.submit();
      });
    });
  }

  /* ==================================================================
     8. Aufdeckungen beim Hereinscrollen
     ================================================================== */
  function initReveals() {
    if (!ANIM) return;

    /* Überschriften wortweise aus der Zeilenmaske */
    $$('[data-anim="lines"]').forEach(function (el) {
      if (el.dataset.animReady) return;
      el.dataset.animReady = "1";
      var words = splitWords(el);
      var targets = words.length ? words : $$(".reveal-line > span", el);
      if (!targets.length) targets = [el];
      targets.forEach(function (t) {
        prep(t, { opacity: "0", transform: "translateY(105%)" },
          "opacity .9s " + EASE + ", transform 1s " + EASE);
      });
      onView(el, function () {
        targets.forEach(function (t, i) { release(t, i * 38); });
      });
    });

    /* Aufblenden */
    $$('[data-anim="fade"]').forEach(function (el) {
      if (el.dataset.animReady) return;
      el.dataset.animReady = "1";
      prep(el, { opacity: "0", transform: "translateY(" + (26 * AMP) + "px)" },
        "opacity .9s " + EASE + ", transform .9s " + EASE);
      onView(el, function () { release(el); });
    });

    /* Gestaffelte Gruppen */
    $$('[data-anim="stagger"]').forEach(function (el) {
      if (el.dataset.animReady) return;
      el.dataset.animReady = "1";
      var kids = Array.prototype.slice.call(el.children);
      if (!kids.length) return;
      kids.forEach(function (k) {
        prep(k, { opacity: "0", transform: "translateY(" + (42 * AMP) + "px)" },
          "opacity .85s " + EASE + ", transform .95s " + EASE);
      });
      onView(el, function () {
        kids.forEach(function (k, i) { release(k, i * 80); });
      });
    });

    /* Bilder fahren hinter ihrem Ausschnitt hervor.
       Bewusst ohne clip-path am beobachteten Element: ein flächenlos
       geclipptes Element meldet dem IntersectionObserver keinen Eintritt. */
    $$(".split__media img, .post__img img, .article__hero img, .card__media img").forEach(function (img) {
      if (img.dataset.animReady) return;
      img.dataset.animReady = "1";
      var frame = img.parentElement;
      prep(img, { opacity: "0", transform: "translateY(14%) scale(1.18)" },
        "opacity 1.1s " + EASE + ", transform 1.4s " + EASE);
      onView(frame, function () { release(img); });
    });

    /* Zahlen zählen hoch */
    $$("[data-count]").forEach(function (el) {
      if (el.dataset.animReady) return;
      el.dataset.animReady = "1";
      var target = parseFloat(el.dataset.count);
      var suf = el.dataset.countSuffix || "";
      onView(el, function () {
        var t0 = performance.now(), dur = 1700;
        (function step(now) {
          var p = clamp((now - t0) / dur, 0, 1);
          var e = 1 - Math.pow(1 - p, 3);
          var n = target % 1 ? (target * e).toFixed(1) : Math.round(target * e);
          el.textContent = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "’") + suf;
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      });
    });

    /* Feine Linien ziehen sich auf. Bewusst nur die dekorative Linie —
       Inhalte werden nie zusammengezogen, sondern nur aufgeblendet. */
    $$("hr.rule").forEach(function (el) {
      if (el.dataset.animReady) return;
      el.dataset.animReady = "1";
      prep(el, { transform: "scaleX(0)", transformOrigin: "left center" }, "transform 1.1s " + EASE);
      onView(el, function () { release(el); });
    });

    $$(".spec").forEach(function (el) {
      if (el.dataset.animReady) return;
      el.dataset.animReady = "1";
      prep(el, { opacity: "0", transform: "translateY(18px)" },
        "opacity .9s " + EASE + ", transform .9s " + EASE);
      onView(el, function () { release(el); });
    });
  }

  /* ==================================================================
     9. Hereinkommen des Heros
     ================================================================== */
  function initHeroIntro() {
    if (!ANIM) return;
    var hero = $(".hero");
    if (!hero || hero.dataset.introReady) return;
    hero.dataset.introReady = "1";

    var copy = $(".hero__copy", hero);
    var viewer = $(".hero__viewer", hero);

    if (copy) {
      Array.prototype.slice.call(copy.children).forEach(function (el, i) {
        if (el.dataset.animReady) return;
        el.dataset.animReady = "1";
        prep(el, { opacity: "0", transform: "translateY(" + (34 * AMP) + "px)" },
          "opacity .9s " + EASE + ", transform .95s " + EASE);
        release(el, 120 + i * 95);
      });
    }
    if (viewer) {
      prep(viewer, { opacity: "0", transform: "translateY(" + (44 * AMP) + "px) scale(.94)" },
        "opacity 1.2s " + EASE + ", transform 1.3s " + EASE);
      release(viewer, 220);
      if (!COARSE) setTimeout(function () { viewer.classList.add("is-floating"); }, 1700);
    }
  }

  /* ==================================================================
     10. Alles, was am Scrollstand hängt — ein einziger Lauf
     ================================================================== */
  function initScrollFx() {
    var header = $(".site-header");
    var totop = $(".totop");
    var progress = $(".scroll-progress");
    var hero = $(".hero");
    var parallax = ANIM ? $$("[data-parallax]") : [];
    var rails = ANIM ? $$("[data-proc-rail]") : [];
    var marquees = $$("[data-marquee]");

    var ticking = false, lastY = window.scrollY, lastT = performance.now(), vel = 0;

    function frame() {
      ticking = false;
      var y = window.scrollY;
      var vh = window.innerHeight;
      var now = performance.now();
      var dt = Math.max(16, now - lastT);
      vel = Math.abs(y - lastY) / dt * 16;
      lastY = y; lastT = now;

      if (header) {
        header.classList.toggle("is-solid", y > 16);
        header.classList.toggle("is-compact", y > 180);
      }
      if (totop) totop.classList.toggle("is-on", y > 600);
      if (progress) {
        var max = document.documentElement.scrollHeight - vh;
        progress.style.transform = "scaleX(" + (max > 0 ? clamp(y / max, 0, 1) : 0) + ")";
      }

      if (!ANIM) return;

      if (hero) {
        var hh = hero.offsetHeight || 1;
        var p = clamp(y / hh, 0, 1);
        hero.style.opacity = String(1 - p * 0.7);
        hero.style.transform = "translateY(" + (-p * 40 * AMP) + "px)";
      }

      parallax.forEach(function (el) {
        var host = el.parentElement || el;
        var r = host.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var prog = (vh - r.top) / (vh + r.height);          /* 0 … 1 im Durchlauf */
        var amt = (parseFloat(el.dataset.parallax) || 10) * AMP;
        el.style.transform = "translateY(" + ((prog - 0.5) * amt) + "%)";
      });

      rails.forEach(function (rail) {
        var inner = rail.firstElementChild;
        if (!inner || window.innerWidth < 900) return;
        var sect = rail.closest("section") || rail;
        var r = sect.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var shift = Math.max(0, inner.scrollWidth - rail.clientWidth);
        if (!shift) return;
        var prog = clamp((vh * 0.72 - r.top) / (r.height + vh * 0.44), 0, 1);
        inner.style.transform = "translateX(" + (-prog * shift) + "px)";
      });

      spinners.forEach(function (s) {
        if (s.mv.hasAttribute("auto-rotate")) return;
        var r = s.el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var prog = clamp((vh * 0.8 - r.top) / (r.height + vh * 0.8), 0, 1);
        s.mv.setAttribute("camera-orbit", (18 + prog * 360) + "deg 78deg 105%");
      });

      marquees.forEach(function (t) {
        if (!t.classList.contains("is-looping")) return;
        var base = parseFloat(t.dataset.marquee) || 28;
        t.style.animationDuration = (base / clamp(1 + vel / 26, 1, 3.4)).toFixed(2) + "s";
      });
    }

    function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", function () { sweep(); request(); }, { passive: true });
    window.addEventListener("resize", function () { sweep(); request(); }, { passive: true });
    window.addEventListener("load", function () { setTimeout(sweep, 200); });
    setTimeout(sweep, 400);
    frame();
  }

  /* ==================================================================
     11. Laufbänder
     ================================================================== */
  function initMarquees() {
    $$("[data-marquee]").forEach(function (track) {
      if (track.dataset.ready) return;
      track.dataset.ready = "1";
      track.innerHTML = track.innerHTML + track.innerHTML;   /* nahtlose Wiederholung */
      if (!ANIM) return;
      track.style.animationDuration = (parseFloat(track.dataset.marquee) || 28) + "s";
      track.classList.add("is-looping");
    });
  }

  /* ==================================================================
     12. Zeigergesteuerte Feinheiten
     ================================================================== */
  function initPointer() {
    if (!ANIM || COARSE) return;

    document.addEventListener("mousemove", function (e) {
      var card = e.target.closest && e.target.closest(".card");
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
      card.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
    }, { passive: true });

    $$("[data-tilt]").forEach(function (el) {
      if (el.dataset.tiltReady) return;
      el.dataset.tiltReady = "1";
      el.addEventListener("mouseenter", function () { el.style.transition = "transform .5s " + EASE; });
      el.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect();
        var rx = -((e.clientY - r.top) / r.height - 0.5) * 7 * AMP;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 7 * AMP;
        el.style.transform = "perspective(900px) rotateX(" + rx + "deg) rotateY(" + ry + "deg) translateY(-6px)";
      });
      el.addEventListener("mouseleave", function () {
        el.style.transition = "transform .8s " + EASE;
        el.style.transform = "";
      });
    });

    $$("[data-magnetic]").forEach(function (el) {
      if (el.dataset.magReady) return;
      el.dataset.magReady = "1";
      el.addEventListener("mouseenter", function () { el.style.transition = "transform .45s " + EASE; });
      el.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = "translate(" +
          ((e.clientX - r.left - r.width / 2) * 0.25 * AMP) + "px," +
          ((e.clientY - r.top - r.height / 2) * 0.25 * AMP) + "px)";
      });
      el.addEventListener("mouseleave", function () {
        el.style.transition = "transform .8s cubic-bezier(.34,1.56,.64,1)";
        el.style.transform = "";
      });
    });
  }

  function initCursor() {
    if (!ANIM || COARSE || A.cursor === false) return;

    var cur = document.createElement("div");
    cur.className = "cursor";
    cur.innerHTML = '<span class="cursor__label"></span>';
    document.body.appendChild(cur);
    var label = cur.firstChild;
    var cx = 0, cy = 0, tx = 0, ty = 0, shown = false;

    window.addEventListener("mousemove", function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!shown) { shown = true; cur.style.opacity = "1"; cx = tx; cy = ty; }
    }, { passive: true });

    (function loop() {
      cx += (tx - cx) * 0.18;
      cy += (ty - cy) * 0.18;
      cur.style.transform = "translate(" + cx + "px," + cy + "px) translate(-50%,-50%)";
      requestAnimationFrame(loop);
    })();

    document.addEventListener("mouseover", function (e) {
      var t = e.target;
      if (!t.closest) return;
      var viewer = t.closest(".media-frame, .viewer");
      var card = t.closest(".card, .lot");
      var link = t.closest("a, button");

      if (viewer && viewer.querySelector("model-viewer")) {
        label.textContent = S.drag || "360°";
        cur.classList.add("is-label"); cur.classList.remove("is-lg");
      } else if (card && S.view) {
        label.textContent = S.view;
        cur.classList.add("is-label"); cur.classList.remove("is-lg");
      } else {
        label.textContent = "";
        cur.classList.remove("is-label");
        cur.classList.toggle("is-lg", !!link);
      }
    });
  }

  /* ==================================================================
     13. Start
     ================================================================== */
  function boot() {
    initShell();
    initCart();
    initQty();
    initMedia();
    initHeroViewer();
    initMarquees();
    initReveals();
    initHeroIntro();
    initScrollFx();
    initPointer();
    initCursor();

    document.addEventListener("shopify:section:load", function () {
      initMedia();
      initHeroViewer();
      initMarquees();
      initReveals();
      initHeroIntro();
      initPointer();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.TOT = { openDrawer: openDrawer, closeDrawer: closeDrawer, formatMoney: formatMoney, toast: toast };
})();
